module.exports = __webpack_public_path__ + "img/resource_03.de6cde43.png";